"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePage = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const ProjectsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectsDataProvider");
const PageLoaderComponent_1 = require("src/configeek_assets/src/components/common/widget/PageLoaderComponent");
const ProjectsErrorPage_1 = require("src/configeek_assets/src/components/loggedIn/content/projects/ProjectsErrorPage");
const react_router_dom_1 = require("react-router-dom");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const antd_1 = require("antd");
const PageContent_1 = require("src/configeek_assets/src/components/common/widget/PageContent");
const ProjectModalComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/ProjectModalComponent");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const HomePage = () => {
    const isMounted = (0, isMounted_1.default)();
    const projectsDataContext = (0, ProjectsDataProvider_1.useProjectsDataContext)();
    const { loaded } = projectsDataContext.projectsCumulativeInfo.status;
    const { isError, error } = projectsDataContext.projectsCumulativeInfo.error;
    const [createProjectModalVisible, setCreateProjectModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onCreateProjectModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setCreateProjectModalVisible({ visible: false });
        }
    }, [isMounted]);
    const onClickCreateProject = (0, react_1.useCallback)(() => {
        setCreateProjectModalVisible({ visible: true, nonce: createProjectModalVisible.nonce + 1 });
    }, [createProjectModalVisible.nonce]);
    if (loaded) {
        if (projectsDataContext.hasProjects()) {
            return React.createElement(react_router_dom_1.Redirect, { to: AppRouter_1.PATH__PROJECTS });
        }
        if (isError && error != undefined) {
            return React.createElement(ProjectsErrorPage_1.ProjectsErrorPage, { error: error });
        }
        return React.createElement(React.Fragment, null,
            React.createElement(antd_1.PageHeader, { title: "Projects" }),
            React.createElement(PageContent_1.PageContent, null,
                React.createElement(PageContent_1.PageContent.CardSpacer, null),
                React.createElement(antd_1.Empty, { description: "You don't have any projects yet.", image: null },
                    React.createElement(ProjectModalComponent_1.ProjectModalComponent, { key: createProjectModalVisible.nonce, visible: createProjectModalVisible.visible, onDestroy: onCreateProjectModalDestroy, ctx: "homePage" }),
                    React.createElement(antd_1.Button, { type: "primary", size: "large", onClick: onClickCreateProject }, "Create Project"))));
    }
    return React.createElement(PageLoaderComponent_1.PageLoaderComponent, null);
};
exports.HomePage = HomePage;
